import { blue, lime, red } from '@mui/material/colors'

export const getLoadCategoryColor = (loadCategory: LoadCategory) => {
  switch (loadCategory) {
    case 'Live':
      return '#0000FF'
    case 'Dead':
      return '#000000'
    case 'Snow':
      return blue[400]
    case 'SnowPlus':
      return blue[400]
    case 'EarthQuake':
      return red[400]
    case 'Wind':
      return red[400]
    default:
      return '#000000'
  }
}

export const highlightLoadColor = lime[400]
